import { createStore, combineReducers } from 'redux'
import { loadingReducer } from './loading/reducer'

const rootReducer = combineReducers({
	loadingReducer: loadingReducer,
})

export const store = createStore(rootReducer)
